/*
<summary>
  Defines the initial state for the Cancelled Reservation list in the User Module.
  This includes default pagination settings and an empty list of cancellation types.
</summary>
*/

import { ICancellationListVM } from "../../models/response/ICancelledReservationResponse";

export const initialState: ICancellationListVM = {
  PagingDetails: {
    TotalRecords: 1,
    TotalPages: 1,
    CurrentPage: 1,
    PageSize: 10,
  },
  CancellationTypeVMs: [],
};
